module.exports = __webpack_public_path__ + "images/emoji/clipboard.23131c39d0d953b4d047.png";